<template>
  <div>
    <div class="p-2 bg-white border-2 border-b-0 rounded-t gap-2 flex items-center justify-between">
      <div>
        <v-btn @click="toggleSelectAll" elevation="0" class="mr-2">{{ $t('select_all') }}</v-btn>
        <v-btn
          class="mr-2"
          @click="isConfirm = true"
          :disabled="selected.length < 1"
          elevation="0"
          color="primary"
        >{{ $t('task.approve_count', { count: selected.length }) }}</v-btn>
        <v-btn
          class="mr-2"
          @click.stop="isCancel = true"
          :disabled="selected.length < 1"
          elevation="0"
          color="error"
        >{{ $t('task.not_approve_count', { count: selected.length }) }}</v-btn>
      </div>
      <div>
        <router-link
          class="router-class blue--text"
          to="setting-task-history"
          style="margin-right:15px;text-decoration: underline;"
        >{{ $t('task.approve_list_setting_history') }}</router-link>
        <v-btn icon elevation="0" color="primary" @click="onInit()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
    </div>
    <template>
      <v-data-table
        show-select
        :headers="headers"
        :items="approveTasks"
        :loading="loading || isLoading"
        :items-per-page="50"
        class="border-2"
        v-model="selected"
        @toggle-select-all="toggleSelectAll"
        item-key="objectId"
        :no-data-text="$t('task.no_send_approve_setting')"
        :no-results-text="$t('no_matching_records_found')"
      >
        <template v-slot:item.areas="{ item }">{{ item.settingTaskAreaCount }} {{ $t('area.space') }}</template>
        <template v-slot:item.settingTaskSum.previous="{ item }">
          <div class="text-end text-no-wrap">
            {{ item.settingTaskSum.previous | currencyPrefixSign(item.currencyCode) }}
          </div>
        </template>
        <template v-slot:item.settingTaskSum.current="{ item }">
          <div class="text-end text-no-wrap">
            {{ item.settingTaskSum.current | currencyPrefixSign(item.currencyCode) }}
          </div>
        </template>
        <template v-slot:item.settingTaskSum="{ item }">
          <div class="text-end text-no-wrap d-inline-block" :class="item.settingTaskSum.class">{{ item.settingTaskSum.diffText | currencyPrefixSign(item.currencyCode,{ mathType: 'outSide' })}}</div>
        </template>
        <!-- <template v-slot:item.taskActions="{ item }">{{ item.getSettingTaskAction }}</template> -->
        <template v-slot:item.createdBy="{ item }">{{ item.createdByFullName }}</template>
        <template v-slot:item.createdAt="{ item }">{{ item.createdAtDateFormat }}</template>
        <template v-slot:item.updatedBy="{ item }">{{ item.updatedByFullName }}</template>
        <template v-slot:item.updatedAt="{ item }">{{ item.updatedAtDateFormat }}</template>
        <template v-slot:item.status="{ item }">
          <div class="max-w-sm flex" style="justify-content: center;">
            <span :class="item.statusColor + ' px-3 py-1 rounded-full '">
              {{
              item.statusString
              }}
            </span>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end">
            <v-btn
              color="grey lighten-4"
              elevation="0"
              rounded
              small
              @click="onClickDetail(item)"
            >{{ $t('detail') }}</v-btn>
          </div>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="isDetail" persistent content-class="dialog-approve-list-setting">
      <v-card outlined :loading="isLoading" min-height="30">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="d-flex justify-space-between" style="width: 100%">
            <span>{{ $t('setting_detail') }}</span>
            <div>
              <v-btn
                @click="exportSettingTask()"
                class="blue white--text"
                :disabled="loading"
                style="margin-right:15px;"
              >
                <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
              </v-btn>
              <v-btn
                color="black"
                icon
                @click="isDetail = false; currentApproveTask = null"
                :disabled="isLoading"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-approve-list-setting-in overflow-y-auto" style="padding:0;">
          <v-data-table
            :loading="isLoading"
            :headers="settingTaskHeaders"
            :items-per-page="50"
            :items="currentSettingTasks "
            class="border-2"
            sort-by="contractId"
            item-key="objectId"
            :no-data-text="$t('noinfo')"
            :no-results-text="$t('no_matching_records_found')"
          >
            <template v-slot:item.name="{ item }">{{item.area.name}}</template>
            <template v-slot:item.action="{ item }">{{item.actionString}} ({{item.typeName}})</template>
            <template v-slot:item.previousPrice="{ item }">
              <div class="text-end text-no-wrap">
                {{item.previousPrice | currencyPrefixSign(item.currencyCode)}}
              </div>
            </template>
            <template v-slot:item.currentPrice="{ item }">
              <div class="text-end text-no-wrap">
                {{item.currentPrice | currencyPrefixSign(item.currencyCode)}}
              </div>
            </template>
            <template v-slot:item.previousOriginalDiscount="{ item }">
              <div class="text-end text-no-wrap">
                {{item.previousOriginalDiscount | currencyPrefixSign(item.currencyCode)}}
              </div>
            </template>
            <template v-slot:item.currentOriginalDiscount="{ item }">
              <div class="text-end text-no-wrap">
                {{item.currentOriginalDiscount | currencyPrefixSign(item.currencyCode)}}
              </div>
            </template>
            <template v-slot:item.diffPrice="{ item }">
              <div class="text-end text-no-wrap d-inline-block" :class="item.diffPrice.class">
                {{item.diffPrice.text | currencyPrefixSign(item.currencyCode,{ mathType: 'outSide' })}}
              </div>
            </template>
            <template v-slot:item.createdBy="{ item }">{{item.createdByFullName}}</template>
            <template v-slot:item.createdAt="{ item }">{{item.createdAtDateFormat}}</template>
            <template v-slot:item.updatedBy="{ item }">{{item.updatedByFullName}}</template>
            <template
              v-slot:item.updatedAt="{ item }"
            >{{item.updatedBy ? item.updatedAtDateFormat : '-'}}</template>
            <template v-slot:item.status="{ item }">{{item.statusString}}</template>
            <template v-slot:item.description="{ item }">
              <div style="text-align:left;">{{item.description || '-'}}</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="isNotApprove = true" :loading="isLoading">
            <v-icon left>mdi-window-close</v-icon>{{ $t('task.not_approve_setting') }}
          </v-btn>
          <v-btn color="success" @click="approveConfirmIn" :loading="isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('task.approve_setting') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="isConfirm"
      class="confirm-dialog-approve"
      :title="`${$t('task.approve')}`"
      :text="`${$t('task.you_want_to_approve_setting', { count: selected.length })}`"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="success"
      @onOk="approveConfirm" />
    <ConfirmDialog
      v-model="isCancel"
      :title="`${$t('task.not_approve')}`"
      :text="`${$t('task.you_want_to_not_approve_setting', { count: selected.length })}`"
      :isNote="true"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="error"
      @onOk="rejectConfirm" />
    <ConfirmDialog
      v-model="isNotApprove"
      :title="`${$t('task.not_approve')}`"
      :text="`${$t('task.you_want_to_not_approve')}`"
      :isNote="true"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="error"
      @onOk="rejectConfirmIn" />
  </div>
</template>


<script>
import { ExportSettingTask } from "../exports";
import Approve from "./Approve.vue";
import { mapGetters } from "vuex";
import ConfirmDialog from "./ConfirmDialog.component";
export default {
  components: { Approve, ConfirmDialog },
  data() {
    return {
      isInterest: false,
      interestId: null,
      approveId: null,
      isConfirm: false,
      isApprove: false,
      isCancel: false,
      isDetail: false,
      currentSettingTasks: [],
      currentApproveTask: null,
      headers: [
        {
          text: this.$t('area.number_of_market_area'),
          align: "center",
          sortable: false,
          value: "areas",
          width: "110px"
        },
        // {
        //   text: "จำนวนการดำเนินการ",
        //   align: "center",
        //   sortable: false,
        //   value: "taskActions"
        // },
        {
          sortable: false,
          text: this.$t('payment.total_amount_before'),
          align: "center",
          value: "settingTaskSum.previous",
          width: "110px"
        },
        {
          sortable: false,
          text: this.$t('payment.total_amount_after'),
          align: "center",
          value: "settingTaskSum.current",
          width: "110px"
        },
        {
          sortable: false,
          text: "",
          align: "right",
          value: "settingTaskSum"
        },
        {
          align: "center",
          value: "createdBy",
          text: this.$t('created_by')
        },
        {
          align: "center",
          value: "createdAt",
          text: this.$t('created_at')
        },
        {
          align: "center",
          value: "updatedBy",
          text: this.$t('change_status_by')
        },
        {
          align: "center",
          value: "updatedAt",
          text: this.$t('change_status_at')
        },
        {
          width: "120px",
          text: this.$t('status'),
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          width: "120px",
          text: "",
          align: "left",
          sortable: false,
          value: "actions"
        }
      ],
      settingTaskHeaders: [
        {
          align: "center",
          value: "name",
          text: this.$t('area.area_name')
        },
        {
          align: "center",
          value: "action",
          text: this.$t('market.action'),
          width: "180px"
        },
        {
          align: "center",
          value: "previousAccountingProduct",
          text: this.$t('payment.original_list')
        },
        {
          align: "center",
          value: "currentAccountingProduct",
          text: this.$t('payment.new_list')
        },
        {
          align: "center",
          value: "previousPrice",
          text: this.$t('payment.original_price')
        },
        {
          align: "center",
          value: "currentPrice",
          text: this.$t('payment.new_price')
        },
        {
          align: "center",
          value: "previousOriginalDiscount",
          text: this.$t('payment.original_discount')
        },
        {
          align: "center",
          value: "currentOriginalDiscount",
          text: this.$t('payment.new_discount')
        },
        {
          align: "center",
          value: "diffPrice",
          text: ""
        },
        {
          align: "center",
          value: "previousType",
          text: this.$t('payment.original_method')
        },
        {
          align: "center",
          value: "currentType",
          text: this.$t('payment.new_method')
        },
        {
          align: "center",
          value: "createdBy",
          text: this.$t('created_by')
        },
        {
          align: "center",
          value: "createdAt",
          text: this.$t('created_at')
        },
        {
          align: "center",
          value: "updatedBy",
          text: this.$t('change_status_by')
        },
        {
          align: "center",
          value: "updatedAt",
          text: this.$t('change_status_at')
        },
        {
          align: "center",
          value: "status",
          text: this.$t('status')
        }
      ],
      items: [],
      selected: [],
      isLoading: false,
      isNotApprove: false,
      canceledNote: ''
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    subType: String,
    approveTasks: Array
  },
  watch: {
    approveTasks() {
    }
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    // approveTasks() {
    //   return this.$store.getters["approveTask/getBySubType"](this.subType);
    // },
    marketId() {
      return this.$route.params.marketId;
    },
    ...mapGetters({
      marketName: "markets/getMarketName"
    })
  },
  methods: {
    onInit() {
      this.$emit("onInit");
    },
    onClickDetail(approveTask) {
      this.currentSettingTasks = [];
      this.currentApproveTask = approveTask;
      if (approveTask.settingTasks && approveTask.settingTasks.length)
        this.currentSettingTasks = approveTask.settingTasks;
      this.isDetail = true;
    },
    afterUpdate(e) {
      this.isInterest = false;
      this.$emit("onInit", true);
      setTimeout(() => {
        this.isInterest = true;
      }, 500);
    },
    toggleSelectAll() {
      if (this.selected.length == this.approveTasks.length) {
        this.selected = [];
      } else {
        this.selected = this.approveTasks;
      }
    },
    async approveConfirm() {
      try {
        this.isLoading = true;
        const approve = this.selected.map(async item => {
          await this.$store.dispatch("approveTask/approveApproveTask", {
            id: item.objectId
          });
        });
        await Promise.all(approve);
        this.$toast.show({
          content: this.$t('task.approve_setting_count', { count: this.selected.length }),
          color: "success"
        });
        this.selected = [];
        this.isConfirm = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.selected = [];
        this.isLoading = false;
        this.isConfirm = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async rejectConfirm({ note }) {
      try {
        this.isLoading = true;
        const approve = this.selected.map(async item => {
          await this.$store.dispatch("approveTask/rejectApproveTask", {
            id: item.objectId,
            cancelledNote: note
          });
        });
        await Promise.all(approve);
        this.$toast.show({
          content: this.$t('task.not_approve_setting_count', { count: this.selected.length }),
          color: "success"
        });
        this.selected = [];
        this.isCancel = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.selected = [];
        this.isLoading = false;
        this.isCancel = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async approveConfirmIn() {
      this.selected = [this.currentApproveTask];
      await this.approveConfirm();
      this.isDetail = false;
    },
    async rejectConfirmIn({ note }) {
      this.selected = [this.currentApproveTask];
      await this.rejectConfirm({ note });
      this.isDetail = false;
    },
    exportSettingTask() {
      try {
        ExportSettingTask.exportSettingTaskByMarket(this.currentSettingTasks);
      } catch (error) {
        this.isError = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-approve-list-setting.v-dialog .dialog-approve-list-setting-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}
</style>